module.exports = __webpack_public_path__ + "img/08-0销售运营管理.c9914d5e.png";